import { getJobNoticeData } from './noticeUtils';

/**
 * Enhanced cell double-click handler that includes role-based alerts functionality
 * This should be used instead of the regular handleCellDoubleClick for cells with job notices
 */
export const createEnhancedCellDoubleClickHandler = (originalHandler, showAlertsCallback) => {
  return (e, job, field, pumpDetails = []) => {
    // Call original handler as fallback
    if (originalHandler) {
      originalHandler(e, job, field);
    }
  };
};

/**
 * Function to check if a user should see alerts modal instead of editing
 * This can be called from the table component
 */
export const shouldShowAlertsModal = (userRoles, job, pumpDetails = []) => {
  console.log('=== shouldShowAlertsModal Debug ===');
  console.log('userRoles received:', userRoles);
  console.log('userRoles.Admin:', userRoles.Admin);
  console.log('userRoles.Scheduling:', userRoles.Scheduling);
  console.log('userRoles.Accounting:', userRoles.Accounting);
  
  // Check if user is admin, scheduling, or accounting
  const isAdminOrScheduling = userRoles.Admin || userRoles.Scheduling;
  const isAccounting = userRoles.Accounting;
  console.log('isAdminOrScheduling:', isAdminOrScheduling);
  console.log('isAccounting:', isAccounting);
  
  // If user has admin/scheduling privileges, allow editing
  if (isAdminOrScheduling) {
    console.log('User has admin/scheduling privileges - allowing normal editing');
    return false;
  }
  
  // If user has accounting role, they should get their specialized modal, not alerts modal
  if (isAccounting) {
    console.log('User has accounting role - should get accounting modal, not alerts modal');
    return false;
  }
  
  // Check if job has notices
  const noticeData = getJobNoticeData(job, pumpDetails);
  console.log('noticeData:', noticeData);
  console.log('noticeData.hasNotices:', noticeData.hasNotices);
  
  // If non-admin, non-accounting user and job has notices, show alerts modal
  const shouldShow = noticeData.hasNotices;
  console.log('shouldShowAlertsModal result:', shouldShow);
  console.log('=====================================');
  
  return shouldShow;
};